import React from "react";

export default function ReadOnlyNotice() {
  return (
    <div
      style={{
        background: "rgba(255,255,255,0.08)",
        border: "1px solid rgba(255,255,255,0.15)",
        color: "#ffffff",
        borderRadius: 8,
        padding: "6px 10px",
        marginBottom: 10,
        fontSize: 13,
        textAlign: "center",
      }}
    >
      🔒 簽核中・此為唯讀檢視模式，表單內容不可修改。
    </div>
  );
}
 